(function (w, d) {
  'use strict';
  if (w.SwissNutriTracking || !w.SwissNutriTrackingConfig) return;
  const cfg = w.SwissNutriTrackingConfig;
  const VERSION = '2026-09-09.1';
  const STAFF_KEY = 'sn_internal_browser_v1';
  const BRIDGE_KEY = 'sn_analytics_bridge_v2';
  const ATTR_KEY = 'sn_attribution_v2';
  const SESSION_MS = 30 * 60 * 1000;
  const host = w.location.hostname.toLowerCase();
  const production = host === 'swissnutri.ch' || host === 'www.swissnutri.ch';
  const query = new URLSearchParams(w.location.search);
  const isPreview = cfg.preview || query.has('preview_theme_id') || !production;
  let ph = null;
  let allowed = false;
  let initialized = false;
  let pageCaptured = false;
  let privacyAttempts = 0;
  const emitted = new Set();
  const storage = {
    get(key) { try { return w.localStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { w.localStorage.setItem(key, value); } catch (_) {} },
    remove(key) { try { w.localStorage.removeItem(key); } catch (_) {} }
  };
  function cleanUrl(value) {
    try {
      const u = new URL(value, w.location.origin);
      if (!['http:', 'https:'].includes(u.protocol)) return '';
      let path = u.pathname;
      if (/\/(?:checkouts?|account|orders)(?:\/|$)/i.test(path)) path = '/' + (path.match(/\/(checkouts?|account|orders)/i) || [,'private'])[1];
      return u.origin + path;
    } catch (_) { return ''; }
  }
  function text(value, max) {
    const s = String(value || '');
    if (/@|\b\d{8,}\b/.test(s)) return '[redacted]';
    return s.slice(0, max || 120);
  }
  function leadType() {
    const handle = cfg.pageHandle || '';
    if (handle === 'private-label' || /\/pages\/private-label(?:\/|$)/.test(w.location.pathname)) return 'private_label';
    if (['vente-en-gros-1', 'wholesale', 'grosshandel', 'vente-en-gros', 'vendita-all-ingrosso'].includes(handle)) return 'wholesale';
    return 'retail';
  }
  function internal() { return storage.get(STAFF_KEY) === '1' || cfg.staffAccount === true; }
  function context() {
    return {
      tracking_version: VERSION, event_source: 'theme', origin_host: production ? 'swissnutri.ch' : host,
      store_key: 'swiss_nutri', shopify_domain: cfg.shopDomain, environment: isPreview ? 'preview' : 'production',
      is_internal: internal(), is_test: isPreview, $internal_or_test_user: internal() || isPreview,
      language: cfg.locale, market_country: cfg.marketCountry, currency: cfg.currency,
      page_type: cfg.pageType, lead_type: leadType(), analytics_consent: true
    };
  }
  function writeCookie(name, value, seconds) {
    try { d.cookie = name + '=' + encodeURIComponent(value) + '; Path=/; Max-Age=' + seconds + '; SameSite=Lax; Secure'; } catch (_) {}
  }
  function attribution() {
    let saved = {};
    try { saved = JSON.parse(storage.get(ATTR_KEY) || '{}'); } catch (_) {}
    if (saved.expires_at < Date.now()) saved = {};
    const campaign = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(k => {
      if (query.has(k)) campaign[k] = text(query.get(k));
    });
    if (!saved.first_touch) saved.first_touch = Object.assign({landing_url: cleanUrl(w.location.href), referrer: cleanUrl(d.referrer)}, campaign);
    if (Object.keys(campaign).length) saved.last_campaign = campaign;
    saved.expires_at = Date.now() + 90 * 86400000;
    storage.set(ATTR_KEY, JSON.stringify(saved));
    return saved;
  }
  function bridge() {
    if (!allowed || !ph || !ph.get_distinct_id || !production || isPreview) return;
    const id = ph.get_distinct_id();
    const sid = ph.get_session_id && ph.get_session_id();
    if (!id || !sid) return;
    const a = attribution();
    const value = Object.assign(context(), {distinct_id: id, session_id: sid, expires_at: Date.now() + SESSION_MS,
      first_touch: a.first_touch, last_campaign: a.last_campaign || {}});
    writeCookie(BRIDGE_KEY, JSON.stringify(value), 1800);
    return d.cookie.split(';').some(function (part) { return part.trim().startsWith(BRIDGE_KEY + '='); });
  }
  function capture(name, properties, onceKey) {
    if (!allowed || !ph) return;
    if (onceKey && emitted.has(onceKey)) return;
    if (onceKey) emitted.add(onceKey);
    bridge();
    ph.capture(name, Object.assign(context(), properties || {}));
  }
  function beforeSend(event) {
    if (!allowed || !event) return null;
    const p = event.properties || (event.properties = {});
    Object.assign(p, context());
    ['$current_url', '$referrer', '$initial_current_url', '$initial_referrer'].forEach(k => { if (p[k]) p[k] = cleanUrl(p[k]); });
    if (p.$pathname) p.$pathname = new URL(cleanUrl(w.location.href)).pathname;
    for (const k of ['email', 'phone', 'name', 'first_name', 'last_name', 'address', '$console_log']) delete p[k];
    for (const key of ['$set', '$set_once']) {
      if (p[key]) {
        for (const k of ['$initial_current_url', '$initial_referrer']) if (p[key][k]) p[key][k] = cleanUrl(p[key][k]);
        if (p[key].$initial_pathname) p[key].$initial_pathname = new URL(cleanUrl(p[key].$initial_pathname)).pathname;
        for (const k of Object.keys(p[key])) if (k.includes('utm_')) p[key][k] = text(p[key][k]);
      }
    }
    for (const k of Object.keys(p)) if (k.includes('utm_')) p[k] = text(p[k]);
    return event;
  }
  function pageEvents() {
    if (pageCaptured || !allowed || !ph) return;
    pageCaptured = true;
    const a = attribution();
    ph.register(context());
    if (internal()) ph.setPersonProperties({$internal_or_test_user: true, is_internal: true});
    capture('$pageview', {first_touch: a.first_touch, last_campaign: a.last_campaign || {}});
    const bridgeWritten = bridge();
    capture('sn_tracking_ready', {identity_bridge_status: bridgeWritten ? 'written' : (isPreview ? 'preview' : 'unavailable')}, 'ready');
    if (cfg.product) {
      const chosen = query.get('variant');
      const variant = cfg.product.variants.find(v => String(v.id) === chosen) || cfg.product.variants.find(v => v.available) || cfg.product.variants[0];
      capture('sn_product_viewed', {product_id: String(cfg.product.id), product_handle: cfg.product.handle,
        variant_id: variant ? String(variant.id) : null, unit_price: variant && variant.price, available: variant && variant.available,
        pack_size: ({'tyrexin-1-packung':1,'tyrexin-3-packungen':3,'tyrexin-6-packungen':6,'tyrexin-10-packungen':10})[cfg.product.handle] || null}, 'product');
    }
    if (cfg.search) capture('sn_search_results_viewed', {result_count: cfg.search.resultCount, has_results: cfg.search.resultCount > 0}, 'search');
    if (leadType() !== 'retail') capture('sn_b2b_page_viewed', {}, 'b2b');
  }
  function start() {
    if (initialized) {
      if (ph && ph.has_opted_out_capturing()) ph.opt_in_capturing();
      pageEvents(); bridge(); return;
    }
    initialized = true;
    w.posthog.init(cfg.token, {
      api_host: cfg.apiHost, defaults: '2026-01-30', capture_pageview: false,
      mask_all_text: true, mask_all_element_attributes: true, capture_exceptions: false,
      enable_recording_console_log: false,
      session_recording: {maskAllInputs: true, maskTextSelector: 'form, [contenteditable], .customer, .klaviyo-form', recordHeaders: false, recordBody: false},
      before_send: beforeSend,
      loaded(instance) {
        ph = instance;
        if (!allowed) { ph.opt_out_capturing(); return; }
        if (ph.has_opted_out_capturing()) ph.opt_in_capturing();
        if (ph.onSessionId) ph.onSessionId(function () { bridge(); });
        pageEvents(); bridge();
      }
    });
  }
  function privacyChanged() {
    const privacy = w.Shopify && w.Shopify.customerPrivacy;
    allowed = !!(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed());
    if (allowed) start();
    else {
      if (ph) { ph.stopSessionRecording(); ph.opt_out_capturing(); }
      writeCookie(BRIDGE_KEY, '', 0); storage.remove(ATTR_KEY);
    }
  }
  function loadPrivacy() {
    if (w.Shopify && w.Shopify.customerPrivacy) { privacyChanged(); return; }
    if (w.Shopify && w.Shopify.loadFeatures) {
      w.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) privacyChanged(); });
    } else if (++privacyAttempts < 30) w.setTimeout(loadPrivacy, 200);
  }
  function setInternal(value) {
    if (value) storage.set(STAFF_KEY, '1'); else storage.remove(STAFF_KEY);
    if (ph && allowed) {
      ph.register(context());
      ph.setPersonProperties({$internal_or_test_user: internal(), is_internal: internal()});
      capture('sn_internal_marker_changed', {is_internal: !!value});
      bridge();
    }
  }
  const staffHash = new URLSearchParams(w.location.hash.replace(/^#/, ''));
  if (staffHash.get('sn-internal') === '1') { setInternal(true); w.history.replaceState(null, '', w.location.pathname + w.location.search); }
  if (staffHash.get('sn-internal') === '0') { setInternal(false); w.history.replaceState(null, '', w.location.pathname + w.location.search); }
  w.SwissNutriTracking = {version: VERSION, capture: capture, setInternal: setInternal,
    status: function () { return {initialized: !!ph, analyticsAllowed: allowed, internal: internal(), environment: isPreview ? 'preview' : 'production'}; }};
  d.addEventListener('visitorConsentCollected', privacyChanged);
  w.addEventListener('klaviyoForms', function (event) {
    const detail = event.detail || {};
    if (!/^[A-Za-z0-9]{6}$/.test(detail.formId || '')) return;
    const names = {open: 'sn_form_viewed', embedOpen: 'sn_form_viewed', submit: 'sn_form_submitted', close: 'sn_form_closed'};
    if (!names[detail.type]) return;
    capture(names[detail.type], {form_id: detail.formId, provider: 'klaviyo', completion_basis: detail.type === 'submit' ? 'provider_conversion_event' : undefined}, detail.type + ':' + detail.formId);
  });
  d.addEventListener('click', function (event) {
    const el = event.target && event.target.closest && event.target.closest('a, button, input[type="submit"]');
    if (!el) return;
    bridge();
    const href = el.getAttribute('href') || '';
    if (/^(mailto:|tel:)/.test(href)) capture('sn_contact_clicked', {contact_method: href.startsWith('mailto:') ? 'email' : 'phone'});
    if (el.name === 'checkout' || /\/checkout(?:\?|$)/.test(href)) capture('sn_checkout_clicked');
  }, true);
  function observeCart(url, response) {
    if (!allowed) return;
    let path;
    try { const u = new URL(typeof url === 'string' ? url : url.url, w.location.href); if (u.origin !== w.location.origin) return; path = u.pathname; } catch (_) { return; }
    const match = path.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/);
    if (!match) return;
    response.clone().json().then(function (body) {
      if (!response.ok || body.status >= 400 || body.errors) {
        capture('sn_cart_error', {cart_action: match[1], http_status: response.status, error_code: Number(body.status) || response.status}); return;
      }
      if (match[1] === 'add') {
        const items = Array.isArray(body.items) ? body.items : [body];
        items.forEach(function (item) {
          capture('sn_cart_add_response', {product_id: String(item.product_id || ''), variant_id: String(item.variant_id || item.id || ''),
            quantity: Number(item.quantity) || 1, unit_price: Number(item.final_price == null ? item.price : item.final_price) / 100});
        });
      } else capture('sn_cart_updated', {cart_action: match[1], item_count: body.item_count, cart_value: Number(body.total_price) / 100});
    }).catch(function () {});
  }
  if (w.fetch) {
    const nativeFetch = w.fetch;
    w.fetch = function () {
      const args = arguments;
      return nativeFetch.apply(this, args).then(function (response) { try { observeCart(args[0], response); } catch (_) {} return response; });
    };
  }
  loadPrivacy();
})(window, document);
